module.exports = __webpack_public_path__ + "img/view-metrics.18cda863.png";